/*=========================================================================================
  File Name: moduleInstitution.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from "./moduleInstitutionState.js"
import mutations from "./moduleInstitutionMutations.js"
import actions from "./moduleInstitutionActions.js"
import getters from "./moduleInstitutionGetters.js"

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

